<div class="modal-box edit-campaign-modal">
    <form class="edit-campaign-modal__form" [formGroup]="editCampaignForm" (ngSubmit)="onSubmit()">
        <div class="modal-header edit-campaign-modal__header">
            <div class="edit-campaign-modal__headline">
                <span class="edit-campaign-modal__eyebrow">{{ 'CAMPAIGN' | translate }}</span>
                <h4 class="modal-title edit-campaign-modal__title">{{ (isEditMode ? 'EDIT_CAMPAIGN' : 'ADD_CAMPAIGN') | translate }}</h4>
            </div>
            <button *ngIf="isModalMode" type="button" class="edit-campaign-modal__close" [attr.aria-label]="'CLOSE' | translate" (click)="onCancel()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body edit-campaign-modal__body">
            <div class="edit-campaign-modal__sections">
                <section class="edit-campaign-modal__panel edit-campaign-modal__panel--wide">
                    <div class="edit-campaign-modal__panel-header">
                        <span class="edit-campaign-modal__panel-eyebrow">{{ 'CAMPAIGN_DETAILS' | translate }}</span>
                    </div>

                    <div class="edit-campaign-modal__details-top-row">
                        <div class="edit-campaign-modal__field edit-campaign-modal__field--grow">
                            <label class="edit-campaign-modal__label" for="name">{{ 'CAMPAIGN_NAME' | translate }}</label>
                            <input type="text" class="form-control edit-campaign-modal__control" formControlName="name"
                                [ngClass]="{ 'is-invalid': submitted && f.name.errors }"
                                placeholder="{{ 'CAMPAIGN_NAME' | translate }}">
                            <div *ngIf="submitted && f.name.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.name.errors?.required">{{ 'NAME_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="edit-campaign-modal__field edit-campaign-modal__field--compact">
                            <label class="edit-campaign-modal__label" for="campaignId">{{ 'CAMPAIGN_ID' | translate }}</label>
                            <input readonly type="text" class="form-control edit-campaign-modal__control" formControlName="campaignId">
                        </div>
                    </div>

                    <div class="edit-campaign-modal__grid edit-campaign-modal__grid--details">

                        <div class="edit-campaign-modal__field">
                            <label class="edit-campaign-modal__label" for="platform">{{ 'PLATFORM' | translate }}</label>
                            <ng-select class="edit-campaign-modal__select" [ngClass]="{ 'is-invalid': submitted && f.platform.errors }"
                                formControlName="platform">
                                <ng-option *ngFor="let p of allPlatforms" [value]="p.value">{{ p.title | translate }}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.platform.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.platform.errors?.required">{{ 'PLATFORM_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="edit-campaign-modal__field">
                            <label class="edit-campaign-modal__label" for="stageId">{{ 'STAGE' | translate }}</label>
                            <ng-select class="edit-campaign-modal__select" [ngClass]="{ 'is-invalid': submitted && f.stageId.errors }"
                                formControlName="stageId">
                                <ng-option *ngFor="let stage of CAMPAIGN_STAGES" [value]="stage.value">{{ stage.translate | translate }}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.stageId.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.stageId.errors?.required">{{ 'STAGE_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div *ngIf="!instance.isAltLayout" class="edit-campaign-modal__field">
                            <label class="edit-campaign-modal__label" for="studioStatus">{{ 'STUDIO_STATUS' | translate }}</label>
                            <ng-select class="edit-campaign-modal__select" [ngClass]="{ 'is-invalid': submitted && f.studioStatus.errors }"
                                formControlName="studioStatus">
                                <ng-option *ngFor="let studioStatus of CAMPAIGN_STUDIO_STATUS" [value]="studioStatus.value">{{ studioStatus.value | P_CampaignStudioStatus }}</ng-option>
                            </ng-select>
                        </div>

                        <div class="edit-campaign-modal__field">
                            <label class="edit-campaign-modal__label" for="clientId">{{ 'CLIENT' | translate }}</label>
                            <ng-select class="edit-campaign-modal__select" [ngClass]="{ 'is-invalid': submitted && f.clientId.errors }"
                                (change)="updateProspectClientDetails()" formControlName="clientId">
                                <ng-option *ngFor="let c of allClients" [value]="c.id">{{ instance.isAltLayout ? c.lastName : ((c.firstName || '') + ' ' + (c.lastName || '')) }}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.clientId.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.clientId.errors?.required">{{ 'CLIENT_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="edit-campaign-modal__field">
                            <label class="edit-campaign-modal__label" for="dmsId">{{ 'DMS' | translate }}</label>
                            <ng-select class="edit-campaign-modal__select" [ngClass]="{ 'is-invalid': submitted && f.dmsId.errors }"
                                formControlName="dmsId">
                                <ng-option *ngFor="let rep of allDms" [value]="rep.id">{{rep.firstName}} {{rep.lastName}}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.dmsId.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.dmsId.errors?.required">{{ 'DMS_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div *ngIf="!instance.isAltLayout" class="edit-campaign-modal__field" [hidden]="f.id?.value === null">
                            <label class="edit-campaign-modal__label" for="subActive">{{ 'ACTIVE_SUBSCRIPTION' | translate }}</label>
                            <div class="edit-campaign-modal__readonly">{{ f.subscriptionActive.value | P_Boolean }}</div>
                        </div>
                    </div>
                </section>

                <section *ngIf="!instance.isAltLayout" class="edit-campaign-modal__panel">
                    <div class="edit-campaign-modal__panel-header">
                        <span class="edit-campaign-modal__panel-eyebrow">{{ 'LOCATION_DETAILS' | translate }}</span>
                    </div>

                    <div class="edit-campaign-modal__grid edit-campaign-modal__grid--location">
                        <div class="edit-campaign-modal__field edit-campaign-modal__field--span-2">
                            <label class="edit-campaign-modal__label" for="street">{{ 'STREET' | translate }}</label>
                            <input type="text" class="form-control edit-campaign-modal__control" formControlName="street"
                                [ngClass]="{ 'is-invalid': submitted && f.street.errors }"
                                [placeholder]="'STREET_ADDRESS' | translate">
                            <div *ngIf="submitted && f.street.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.street.errors?.required">{{ 'STREET_REQUIRED' | translate }}</div>
                                <div *ngIf="f.street.errors.max">{{ 'STREET_MAX' | translate }}</div>
                            </div>
                        </div>

                        <div class="edit-campaign-modal__field">
                            <label class="edit-campaign-modal__label" for="city">{{ 'CITY' | translate }}</label>
                            <input type="text" class="form-control edit-campaign-modal__control" formControlName="city"
                                [ngClass]="{ 'is-invalid': submitted && f.city.errors }"
                                [placeholder]="'CITY' | translate">
                            <div *ngIf="submitted && f.city.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.city.errors?.max">{{ 'CITY_MAX' | translate }}</div>
                            </div>
                        </div>

                        <div class="edit-campaign-modal__field">
                            <label class="edit-campaign-modal__label" for="state">{{ 'STATE' | translate }}</label>
                            <input type="text" class="form-control edit-campaign-modal__control" formControlName="state"
                                [ngClass]="{ 'is-invalid': submitted && f.state.errors }"
                                [placeholder]="'STATE' | translate">
                            <div *ngIf="submitted && f.state.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.state.errors?.max">{{ 'STATE_MAX' | translate }}</div>
                            </div>
                        </div>

                        <div class="edit-campaign-modal__field">
                            <label class="edit-campaign-modal__label" for="zipcode">{{ 'ZIPCODE' | translate }}</label>
                            <input type="text" class="form-control edit-campaign-modal__control" formControlName="zipcode"
                                [ngClass]="{ 'is-invalid': submitted && f.zipcode.errors }"
                                [placeholder]="'ZIPCODE' | translate">
                            <div *ngIf="submitted && f.zipcode.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.zipcode.errors?.max">{{ 'ZIPCODE_MAX' | translate }}</div>
                            </div>
                        </div>

                        <div class="edit-campaign-modal__field">
                            <label class="edit-campaign-modal__label" for="locationPhone">{{ 'PHONE' | translate }}</label>
                            <input type="text" class="form-control edit-campaign-modal__control" formControlName="locationPhone"
                                [ngClass]="{ 'is-invalid': submitted && f.locationPhone.errors }"
                                [placeholder]="'PHONE' | translate">
                            <div *ngIf="submitted && f.locationPhone.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.locationPhone.errors?.required">{{ 'PHONE_REQUIRED' | translate }}</div>
                                <div *ngIf="f.locationPhone.errors?.max">{{ 'PHONE_MAX' | translate }}</div>
                            </div>
                        </div>

                        <div class="edit-campaign-modal__field edit-campaign-modal__field--span-2">
                            <label class="edit-campaign-modal__label" for="locationEmail">{{ 'EMAIL' | translate }}</label>
                            <input type="text" class="form-control edit-campaign-modal__control" formControlName="locationEmail"
                                [ngClass]="{ 'is-invalid': submitted && f.locationEmail.errors }"
                                [placeholder]="'EMAIL' | translate">
                            <div *ngIf="submitted && f.locationEmail.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.locationEmail.errors?.required">{{ 'EMAIL_REQUIRED' | translate }}</div>
                                <div *ngIf="f.locationEmail.errors?.max">{{ 'EMAIL_MAX' | translate }}</div>
                                <div *ngIf="f.locationEmail.errors?.email">{{ 'EMAIL_INVALID' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section *ngIf="!instance.isAltLayout || !isExternal || isAdmin" class="edit-campaign-modal__panel">
                    <div class="edit-campaign-modal__panel-header">
                        <span class="edit-campaign-modal__panel-eyebrow">{{ 'CRM_INTERNAL_CONTEXT' | translate }}</span>
                    </div>

                    <div class="edit-campaign-modal__grid edit-campaign-modal__grid--ops">
                        <div *ngIf="!instance.isAltLayout" class="edit-campaign-modal__field edit-campaign-modal__field--span-2">
                            <label class="edit-campaign-modal__label" for="crmName">{{ 'CRM_NAME' | translate }}</label>
                            <div class="edit-campaign-modal__crm-row">
                                <ng-select *ngIf="!isCustomCrmName" class="edit-campaign-modal__select edit-campaign-modal__select--grow" formControlName="crmName">
                                    <ng-option *ngFor="let c of defaultCRMNames" [value]="c.value">{{c.title | translate }}</ng-option>
                                </ng-select>
                                <input *ngIf="isCustomCrmName" type="text" class="form-control edit-campaign-modal__control edit-campaign-modal__control--grow" formControlName="crmName"
                                    [ngClass]="{ 'is-invalid': submitted && f.crmName.errors }"
                                    [placeholder]="'CRM_NAME' | translate">
                                <button *ngIf="isCustomCrmName" type="button" class="edit-campaign-modal__icon-button"
                                    (click)="onShowDropdown()" [title]="'SHOW_DROPDOWN' | translate" [attr.aria-label]="'SHOW_DROPDOWN' | translate">
                                    <i-feather name="corner-right-up" class="icon-sm icon"></i-feather>
                                </button>
                            </div>
                            <div *ngIf="submitted && f.crmName.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.crmName.errors?.required">{{ 'CRM_NAME_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div *ngIf="!instance.isAltLayout" class="edit-campaign-modal__field">
                            <label class="edit-campaign-modal__label" for="crmId">{{ 'CRM_ID' | translate }}</label>
                            <input type="text" class="form-control edit-campaign-modal__control" formControlName="crmId"
                                [ngClass]="{ 'is-invalid': submitted && f.crmId.errors }" [placeholder]="'CRM_ID' | translate">
                            <div *ngIf="submitted && f.crmId.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.crmId.errors?.required">{{ 'CRM_ID_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div *ngIf="!isExternal || isAdmin" class="edit-campaign-modal__field edit-campaign-modal__field--span-2">
                            <label class="edit-campaign-modal__label" for="opportunityNotes">{{ 'INTERNAL_NOTES' | translate }}</label>
                            <textarea rows="4" class="form-control edit-campaign-modal__control edit-campaign-modal__control--textarea" formControlName="opportunityNotes"
                                [ngClass]="{ 'is-invalid': submitted && f.opportunityNotes.errors }"
                                placeholder="{{ 'INTERNAL_NOTES_PLACEHOLDER' | translate }}"></textarea>
                            <div *ngIf="submitted && f.opportunityNotes.errors" class="edit-campaign-modal__feedback">
                                <div *ngIf="f.opportunityNotes.errors?.required">{{ 'INTERNAL_NOTES_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="edit-campaign-modal__panel edit-campaign-modal__panel--wide">
                    <div class="edit-campaign-modal__panel-header edit-campaign-modal__panel-header--split">
                        <div>
                            <span class="edit-campaign-modal__panel-eyebrow">{{ 'AD_ACCOUNT_INFO' | translate }}</span>
                        </div>
                        <button *ngIf="!isAddAcountMode" type="button" class="btn btn-sm btn-black edit-campaign-modal__account-add" (click)="OnAddAccontClick()">{{ 'ADD_ACCOUNT' | translate }}</button>
                    </div>

                    <div class="edit-campaign-modal__accounts">
                        <div class="edit-campaign-modal__table-wrap" *ngIf="campaignAdAccounts?.length != 0">
                            <table id="adAcccounts" class="edit-campaign-modal__accounts-table">
                                <tr>
                                    <td><strong>{{ 'AD_ACCOUNT_ID' | translate }}</strong></td>
                                    <td><strong>{{ 'AD_CAMPAIGN_ID' | translate }}</strong></td>
                                    <td><strong>{{ 'AD_LABEL' | translate }}</strong></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr *ngFor="let ad of campaignAdAccounts;">
                                    <td>{{ad.platformAccountID}}</td>
                                    <td>{{ad.platformCampaignID}}</td>
                                    <td>{{ad.adLabel}}</td>
                                    <td class="edit-campaign-modal__table-action-cell">
                                        <span class="input-group-text edit-campaign-modal__table-action"
                                            title="{{ 'CLICK_TO_EDIT_AD_ACCOUNT' | translate }}" (click)="onEditAccountClick(ad.id)">
                                            <i class="fa-solid fa-pen-to-square"></i>
                                        </span>
                                    </td>
                                    <td class="edit-campaign-modal__table-action-cell">
                                        <span class="input-group-text edit-campaign-modal__table-action"
                                            title="{{ 'CLICK_TO_REMOVE_AD_ACCOUNT' | translate }}" (click)="deleteAdAccount(ad)">
                                            <i class="fas fa-times"></i>
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <div *ngIf="isAddAcountMode" class="edit-campaign-modal__account-editor">
                            <div class="edit-campaign-modal__grid edit-campaign-modal__grid--account-editor">
                                <div class="edit-campaign-modal__field">
                                    <label class="edit-campaign-modal__label">{{ 'PLATFORM_ACCOUNT_ID' | translate }}</label>
                                    <input type="text" class="form-control edit-campaign-modal__control" [(ngModel)]="currentAccountId" [ngModelOptions]="{standalone: true}"
                                        [ngClass]="{ 'is-invalid': isAddAccountSubmitted && currentAccountId.trim().length == 0 }"
                                        placeholder="{{ 'PLATFORM_ACCOUNT_ID' | translate }}">
                                    <div *ngIf="isAddAccountSubmitted && currentAccountId.trim().length == 0" class="edit-campaign-modal__feedback">
                                        <div>{{ 'PLATFORM_ACCOUNT_ID_REQUIRED' | translate }}</div>
                                    </div>
                                </div>

                                <div class="edit-campaign-modal__field">
                                    <label class="edit-campaign-modal__label">{{ 'PLATFORM_CAMPAIGN_ID' | translate }}</label>
                                    <input type="text" class="form-control edit-campaign-modal__control" [(ngModel)]="currentCampaignId" [ngModelOptions]="{standalone: true}"
                                        [ngClass]="{ 'is-invalid': isAddAccountSubmitted && currentCampaignId.trim().length == 0 }"
                                        placeholder="{{ 'PLATFORM_CAMPAIGN_ID' | translate }}">
                                    <div *ngIf="isAddAccountSubmitted && currentCampaignId.trim().length == 0" class="edit-campaign-modal__feedback">
                                        <div>{{ 'PLATFORM_CAMPAIGN_ID_REQUIRED' | translate }}</div>
                                    </div>
                                </div>

                                <div class="edit-campaign-modal__field">
                                    <label class="edit-campaign-modal__label">{{ 'PLATFORM_AD_LABEL' | translate }}</label>
                                    <input type="text" class="form-control edit-campaign-modal__control" [(ngModel)]="currentAdLabel" [ngModelOptions]="{standalone: true}"
                                        [ngClass]="{ 'is-invalid': isAddAccountSubmitted && currentAdLabel.trim().length == 0 }"
                                        placeholder="{{ 'PLATFORM_AD_LABEL' | translate }}">
                                </div>
                            </div>

                            <div class="edit-campaign-modal__account-actions">
                                <button *ngIf="!isUpdateAccountMode" [disabled]="currentCampaignId.trim().length == 0 || currentAccountId.trim().length == 0" type="button" class="btn btn-sm btn-dark" (click)="addAccountDetail()">
                                    {{ 'ADD' | translate }}</button>
                                <button *ngIf="isUpdateAccountMode" [disabled]="currentCampaignId.trim().length == 0 || currentAccountId.trim().length == 0" type="button" class="btn btn-sm btn-dark" (click)="updateAccountDetail()">
                                    {{ 'UPDATE' | translate }}</button>
                                <button type="button" class="btn btn-sm btn-dark" (click)="CancelAddMode()">
                                    {{ 'CANCEL' | translate }}</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-footer edit-campaign-modal__footer">
            <div class="edit-campaign-modal__actions">
                <button type="button" class="red-outline-button add-lead-modal__button modal-button" (click)="onCancel()">{{ 'CANCEL' | translate }}</button>
                <button class="blue-button edit-campaign-modal__button edit-campaign-modal__button--primary" type="submit">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
